var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flashlight-wrapper",on:{"click":function($event){return _vm.$emit('flashlightClick')}}},[_c('div',{staticClass:"flashlight-tile-holder"},[_vm._l((_vm.maxPower),function(power){return [_c('div',{key:power,class:_vm.energyClass(power)})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }